export default (theme) => ({
  switchRow: {
    marginTop: 16,
  },
  label: {
    color: theme.palette.textColor.secondary,
    fontSize: '0.8rem',
    fontWeight: 400,
    marginLeft: 10,
    display: 'inline-block',
    verticalAlign: 'middle',
  },
});
